import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "File Magnifying Glass Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M231.32 72.927 163.774 5.382a9.65 9.65 0 0 0-6.827-2.822H41.157c-10.659 0-19.298 8.64-19.298 19.299v212.283c0 10.658 8.64 19.299 19.298 19.298h173.686c10.659 0 19.299-8.64 19.299-19.298V79.754a9.65 9.65 0 0 0-2.823-6.827M166.596 35.5 201.2 70.105h-34.604Zm48.246 198.642H41.157V21.859h106.142v57.895c0 5.33 4.32 9.65 9.649 9.65h57.895zm-54.928-58.921c17.828-28.33-1.697-65.335-35.145-66.61s-55.733 34.137-40.113 63.741c11.815 22.393 40.188 29.996 61.616 16.51l13.497 13.51c5.255 5.255 14.229 2.85 16.152-4.329a9.65 9.65 0 0 0-2.498-9.325Zm-60.863-23.098c0-18.57 20.103-30.176 36.185-20.891s16.082 32.497 0 41.782a24.1 24.1 0 0 1-12.062 3.232c-13.323 0-24.123-10.8-24.123-24.123" }, null, -1)
  ])))
}
export default { render: render }